import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Hero Simple',
  name: 'heroSimple',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'name',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
    }),
    defineField({
      title: 'Buttons',
      name: 'buttons',
      type: 'array',
      of: [
        {
          title: 'Button',
          type: 'link',
          name: 'button',
        },
      ],
      validation: (rule) => rule.max(2),
    }),
  ],
})